import React, { useCallback, useState, useEffect } from "react";

import { IconChevronRight, IconChevronLeft } from "@at/design-system-icons";

import * as Styled from "./leasing-banner-carousel.styled";
import { LeasingModals } from "../../../../contexts/leasing/types/leasing.types";

import { useTracking } from "../../../../utils/tracking/use-tracking";
import {
  BannerItemButton,
  BannerItemLink,
  BannerItemText,
} from "../leasing-banner.styled";
import { LeasingBannerLayoutProps } from "../leasing-banner.types";
export const BannerCarousel = ({
  handleOpenModal,
  bannerData,
}: LeasingBannerLayoutProps) => {
  const [index, setIndex] = useState(0);
  const [stopTimer, setStopTimer] = useState(false);
  const { trackEvent } = useTracking();
  // handle the step change for the carousel
  const handleStepChange = useCallback(
    (stepChange: 1 | -1) => {
      setIndex((prevIndex) => {
        const newIndex = prevIndex + stepChange;
        // if the index is less than 0, set it to the last item in the carousel
        if (newIndex < 0) {
          return bannerData.length - 1;
        }
        // if the index is greater than the last index, set it to first item in carousel
        if (newIndex >= bannerData.length) {
          return 0;
        }
        return newIndex;
      });
    },
    [bannerData.length],
  );

  useEffect(() => {
    // handle the carousel timer and stop it when above 768px or when the user interacts with the carousel
    if (!stopTimer) {
      const slider = setInterval(() => {
        handleStepChange(1);
      }, 5000);
      return () => clearInterval(slider);
    }
  }, [stopTimer, handleStepChange]);

  return (
    <div data-testid="leasing-banner-carousel">
      <Styled.NavPrevButton
        onClick={() => {
          handleStepChange(-1);
          setStopTimer(true);
        }}
      >
        <IconChevronLeft title="" size={18} />
      </Styled.NavPrevButton>
      {bannerData.map((item, itemIndex) => {
        let position = "nextSlide";
        if (itemIndex === index) {
          position = "activeSlide";
        }
        if (
          itemIndex === index - 1 ||
          (index === 0 && itemIndex === bannerData.length - 1)
        ) {
          position = "lastSlide";
        }
        return (
          <Styled.BannerItem key={itemIndex} className={position}>
            <Styled.BannerItemContentWrapper>
              {item.link ? (
                <BannerItemLink
                  href={item.link}
                  onClick={() => trackEvent({ trackingLabel: item.tracking })}
                >
                  {item.icon}
                  <BannerItemText aria-describedby="required-description">
                    {item.text}
                  </BannerItemText>
                </BannerItemLink>
              ) : (
                <BannerItemButton
                  onClick={() => {
                    handleOpenModal({
                      type: item?.modal ?? LeasingModals.NONE,
                      title: item.title,
                      tracking: item.tracking,
                    });
                  }}
                >
                  {item.icon}
                  <BannerItemText aria-describedby="required-description">
                    {item.text}
                  </BannerItemText>
                </BannerItemButton>
              )}
            </Styled.BannerItemContentWrapper>
          </Styled.BannerItem>
        );
      })}
      <Styled.NavNextButton
        onClick={() => {
          handleStepChange(1);
          setStopTimer(true);
        }}
      >
        <IconChevronRight title="" size={18} />
      </Styled.NavNextButton>
    </div>
  );
};
